import {
  Add,
  ArrowBack,
  ArrowForward,
  Delete,
  Edit,
  MoreVert,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import NoDataFound from "../CustomComponents/NoDataFound";
import { MandateReturnReducerAction } from "../Store/MandateReturnReducer";
import MandateReturnInfo from "./MandateReturnInfo";
import store from "./../Store/index";
import axios from "axios";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";

const MandateReturnList = () => {
  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const formData = useSelector((state) => state.mandateReturn.data);
  const datarows = useSelector((state) => state.mandateReturn.gridRows);
  const gridPaginationData = useSelector(
    (state) => state.mandateReturn.gridPaginationData
  );
  const filteredFormData = useSelector(
    (state) => state.mandateReturn.filterData
  );
  const userName = useSelector((state) => state.branch.userName);

  const [open, setOpen] = useState(false);
  const [dlgbtnName, setDlgBtnName] = useState("NEXT");
  const [dlgInputMode, setDlgInputMode] = useState(false);
  const [mandateNumErrorMsg, setMandateNumErrorMsg] = useState(
    "Please Enter Mandate Number"
  );
  const [deleteOperationActive, setDeleteOperationActive] =
    React.useState(false);
  const saveBtnDisable = useSelector(
    (state) => state.mandateReturn.saveBtnDisable
  );
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  //Input Validtion
  const returnReasonValid =
    formData.returnReason !== undefined &&
    formData.returnReason !== "" &&
    formData.returnReason !== null;
  const chargesValid =
    formData.charges !== undefined &&
    formData.charges !== null &&
    formData.charges !== "" &&
    formData.charges === 0 &&
    formData.charges !== "0";
  const mandateNumValid =
    formData.mandateNum !== undefined &&
    formData.mandateNum !== "" &&
    formData.mandateNum !== null;
  const voucherNumValid =
    formData.voucherNum !== undefined &&
    formData.voucherNum !== "" &&
    formData.voucherNum !== null;
  //Has Error
  const returnReasonHasError = formData.returnReasonError && !returnReasonValid;
  const voucherNumHasError = formData.voucherNumTouch && !voucherNumValid;
  const chargesHasError = formData.chargesError && !chargesValid;
  const mandateNumHasError =
    (formData.mandateNumError && !mandateNumValid) || formData.mandateNumError;

  const columns = [
    {
      field: "addRecord",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 50,
      hideable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return !params.value ? (
          <IconButton size="small">
            <Edit
              fontSize="small"
              sx={{ color: "#004A92", fontWeight: 700 }}
              onClick={() => onRowEditClick(params.row)}
            />
          </IconButton>
        ) : (
          <LoadActionBtn
            record={params.row}
            onMoreActionsClick={(value, record) =>
              onMoreActionBtnClick(value, record)
            }
          />
        );
      },
    },
    {
      field: "mandateNum",
      headerName: "Mandate Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "voucherNum",
      headerName: "Voucher Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "mandateDate",
      headerName: "Mandate Date",
      headerAlign: "center",
      align: "right",
      flex: 200,
      hideable: false,
      sortable: false,
      filterable: false,
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "mandateAmt",
      headerName: "Mandate Amount",
      headerAlign: "center",
      align: "right",
      flex: 190,
      hideable: false,
      renderCell: (params) => {
        return params.value === "0"
          ? 0
          : parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "returnReason",
      headerName: "Return Reason",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "charges",
      headerName: "Charges",
      headerAlign: "center",
      align: "right",
      flex: 185,
      hideable: false,
      renderCell: (params) => {
        return params.value === "0"
          ? 0
          : parseInt(params.value).toLocaleString("en-IN");
      },
    },
  ];

  const [gridColumns, setGridColumns] = React.useState(columns);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  useEffect(() => {
    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    setRows([...datarows].slice(0, 10));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    // this is for mobile ->  value  + 1;
    setPage(gridPaginationData.lastActivePage + 1);
    if (gridPaginationData.lastActivePage !== 0 && deviceMode === "MOBILE") {
      // in case of mobile if page is not first navigate to that page using auto call of handle change.
      // in this case event be null.
      handlePageChange(null, gridPaginationData.lastActivePage + 1);
    }
  }, [datarows, saveBtnDisable]);

  useLayoutEffect(() => {}, [saveBtnDisable]);
  //shortcut key

  const addRowRef = useRef(null);
  const saveRef = useRef(null);
  const cancelRef = useRef(null);
  const okRef = useRef(null);
  const cancelDialogRef = useRef(null);
  const yesRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "mandateReturnList",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      closeDialog();
    }
    if (event.ctrlKey) {
      if (charCode === "a") {
        addRowRef.current.click();
      } else if (charCode === "s") {
        saveRef.current.click();
      } else if (charCode === "q") {
        cancelRef?.current?.click();
        cancelDialogRef?.current?.click();
      } else if (charCode === "k") {
        okRef.current.click();
      } else if (charCode === "y") {
        yesRef.current.click();
      }
    }
  };

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
    const currentPage = { lastActivePage: newPage };
    dispatch(MandateReturnReducerAction.updateGridPaginationData(currentPage));
  };

  const onMoreActionBtnClick = (value, record) => {
    // get the latest records.
    let latestRecords = store.getState().mandateReturn.gridRows;
    switch (value) {
      case "Edit":
        onRowEditClick(record);
        break;
      case "Delete":
        setDeleteOperationActive(true);
        setTimeout(() => {
          let rowsData = [...latestRecords];
          let filteredData = rowsData.filter(
            (row) => row.voucherNum !== record.voucherNum
          );
          dispatch(
            MandateReturnReducerAction.updateGridRows([...filteredData])
          );
          if (deviceMode === "MOBILE") {
            let pageNumberValue =
              filteredData.length % 10 === 0
                ? filteredData.length / 10 - 1
                : Math.floor(filteredData.length / 10);
            handlePageChange(null, pageNumberValue);
          } else {
            // desktop -> 5 records per page.
            // check the page number.
            let pageNumberValue =
              filteredData.length % 5 === 0
                ? filteredData.length / 5 - 1
                : Math.floor(filteredData.length / 5);
            onGridPageChange(pageNumberValue);
          }
          setTimeout(() => {
            setDeleteOperationActive(false);
          }, 1000);
        }, 100);

        break;

      default:
        break;
    }
  };

  const onDlgOkClick = () => {
    if (!dlgInputMode) {
      const voucherNumValue = formData.voucherNum;
      const updatedRecord = { ...formData };
      let recordsData = [...datarows];
      let updateRows = recordsData.map((record) => {
        if (record.voucherNum === voucherNumValue) {
          const recordData = {
            ...record,
            returnReason: updatedRecord.returnReason,
            charges: updatedRecord.charges,
            mandateDate: dayjs(updatedRecord.mandateDate).format("DD/MM/YYYY"),
          };
          return recordData;
        }
        return record;
      });
      dispatch(MandateReturnReducerAction.updateGridRows([...updateRows]));
    } else {
      let rowsData = [...datarows];
      let record = { ...formData };
      const records = record.mandateNumRecords;
      const voucherNums = [...records].map((record) => record.voucherNum);
      const filteredRecords = rowsData.filter((existRecord) =>
        voucherNums.includes(existRecord.voucherNum)
      );
      // checking for duplicate and if not exist add record.
      if (filteredRecords.length === 0) {
        const updatedRecords = records.map((row) => {
          let currentRow = { ...row };
          currentRow.addRecord = true;
          currentRow.id =
            row.mandateNum + "-" + row.applicationNum + "-" + row.voucherNum;
          currentRow.mandateDate = dayjs(record.mandateDate).format(
            "DD/MM/YYYY"
          );
          currentRow.returnReason = record.returnReason;
          return currentRow;
        });
        rowsData = rowsData.concat([...updatedRecords]);
        dispatch(MandateReturnReducerAction.updateGridRows([...rowsData]));
      } else {
        setMessage("Mandate Number is Already Added.");
        setAlertType("error");
        openAlertHandler();
      }

      if (deviceMode === "MOBILE") {
        let pageNumberValue =
          rowsData.length % 10 === 0
            ? rowsData.length / 10 - 1
            : Math.floor(rowsData.length / 10);
        handlePageChange(null, pageNumberValue);
      } else {
        // desktop -> 5 records per page.
        // check the page number.
        let pageNumberValue =
          rowsData.length % 5 === 0
            ? rowsData.length / 5 - 1
            : Math.floor(rowsData.length / 5);
        onGridPageChange(pageNumberValue);
      }
    }

    closeDialog();
  };

  const closeDialog = () => {
    setOpen(false);
    setTimeout(() => {
      setDlgBtnName("NEXT");
      setMandateNumErrorMsg("");
      dispatch(MandateReturnReducerAction.resetValues(true));
      dispatch(
        MandateReturnReducerAction.updateReturnReasonTouchHandler(false)
      );
      dispatch(MandateReturnReducerAction.updateBranchTouchHandler(false));
      dispatch(MandateReturnReducerAction.updateMandateNumErrorHandler(false));
    }, 1000);
  };

  const rowDoubleClickHandler = (event) => {
    // Do nothing.
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const onRowEditClick = async (row) => {
    // reload voucher nums based on selected checque number before edit.
    try {
      const branchCodeValue = getSelectedBranchCode(
        filteredFormData.branchValue
      );
      const response = await axios.post("/mandate/getMandateVoucherNum", {
        mandateNum: row.mandateNum,
        branch: filteredFormData.branchValue,
        branchCode: branchCodeValue,
        voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
          "MM/DD/YYYY"
        ),
      });
      let responseModelData = response.data;
      const voucherNums = responseModelData.voucherNumList;
      dispatch(MandateReturnReducerAction.updateVoucherNumArray(voucherNums));
      setDlgBtnName("OK");
      // get the return reason value before reset.
      const returnReasonArrayValues = { ...formData }.returnReasonArray;
      var record = { ...row };
      // get the latest records & filter the records based on edited row voucher num.
      const latestRecords = store.getState().mandateReturn.gridRows;
      const currentEditVoucherNumRows = [...latestRecords].filter(
        (row) => row.voucherNum === record.voucherNum
      );

      const mandateAmt = Number(
        [...currentEditVoucherNumRows]
          .map((row) => Number(row.mandateAmt))
          .reduce((a, b) => a + b)
      );
      const charges = Number(
        [...currentEditVoucherNumRows]
          .map((row) => Number(row.charges))
          .reduce((a, b) => a + b)
      );
      const appNum = [...currentEditVoucherNumRows]
        .map((row) => row.applicationNum + ", ")
        .reduce((a, b) => a + b);

      record.applicationNum = appNum;
      record.mandateAmt = mandateAmt;
      record.charges = charges;
      // update the date format.
      var mandateDateString = record.mandateDate;
      var dateParts = mandateDateString.split("/");

      // month is 0-based, that's why we need dataParts[1] - 1
      var mandateDateObject = new Date(
        +dateParts[2],
        dateParts[1] - 1,
        +dateParts[0]
      );
      record.mandateDate = dayjs(mandateDateObject);
      record.voucherNumArray = [...voucherNums];
      record.returnReasonArray = returnReasonArrayValues;
      dispatch(MandateReturnReducerAction.updateValues(record));
      setDlgInputMode(false);
      setOpen(true);
    } catch (error) {
      setMessage("Mandate Number related Voucher Numbers Load Failed.");
      setAlertType("error");
      openAlertHandler();
      console.log(error);
      throw Error(error);
    }
  };

  const onGridPageChange = (newPage) => {
    const currentPage = { lastActivePage: newPage };
    dispatch(MandateReturnReducerAction.updateGridPaginationData(currentPage));
  };

  const handleDialogClose = () => {
    dispatch(MandateReturnReducerAction.updateSaveBtnDisable(false));
    setDialogOpen(false);
  };

  const openAlertDialog = () => {
    setDialogMessage("Are you sure want to return mandate?");
    setDialogTitleMessage("Confirmation");
    setDialogOpen(true);
  };

  const onSaveButtonClickHandler = async () => {
    setDialogOpen(false);
    try {
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === filteredFormData.branchValue;
      });
      // get the latest records for save.
      const latestRecords = store.getState().mandateReturn.gridRows;
      const recordsData = latestRecords.map((row) => {
        // update the date format.
        let recordValue = { ...row };
        let chequeDateString = recordValue.mandateDate;
        let dateParts = chequeDateString.split("/");

        // month is 0-based, that's why we need dataParts[1] - 1
        let chequeDateObject = new Date(
          +dateParts[2],
          dateParts[1] - 1,
          +dateParts[0]
        );
        recordValue.mandateDate = dayjs(chequeDateObject);
        recordValue.branchCode = branchCodeValue.code;
        recordValue.createdBy = userName;
        recordValue.lastModifiedBy = userName;
        return recordValue;
      });
      // // validate duplicate mandate return by other user before save.
      // const duplicateMandateCheckResponse = await axios.post(
      //   "/mandate/mandateDuplicateCheck",
      //   {
      //     mandateReturnList: recordsData,
      //   }
      // );
      // if (
      //   duplicateMandateCheckResponse.status === 200 &&
      //   duplicateMandateCheckResponse.data.length > 0
      // ) {
      //   let errorMsg = "Mandate Numbers Already Returned by other User :  ";
      //   let errorMandateNums = "";
      //   [...duplicateMandateCheckResponse.data].forEach(
      //     (record) => errorMandateNums + record.mandateNum + ", "
      //   );
      //   errorMsg = errorMsg + errorMandateNums;
      //   setMessage(errorMsg);
      //   setAlertType("error");
      //   openAlertHandler();
      //   return;
      // }

      // if no duplicate mandates added exist which is saved by other user, then proceed to save.
      const response = await axios.post(
        "/mandate/insertOrUpdateMandateReturn",
        {
          mandateReturnList: recordsData,
        }
      );
      let records = [...response.data].map((row) => {
        let recordValue = { ...row };
        recordValue.id = recordValue.mandateNum;
        recordValue.mandateDate = dayjs(recordValue.mandateDate).format(
          "DD/MM/YYYY"
        );
        return recordValue;
      });
      dispatch(MandateReturnReducerAction.updateGridRows([...records]));
      setMessage("Mandate Return Saved Successfully.");
      setAlertType("success");
      openAlertHandler();
      setTimeout(() => {
        dispatch(MandateReturnReducerAction.resetFilterValues());
        dispatch(MandateReturnReducerAction.updateBranchTouchHandler(false));
        dispatch(
          MandateReturnReducerAction.updateVoucherDateTouchHandler(false)
        );
        dispatch(MandateReturnReducerAction.updateShowMandateReturnList(false));
        dispatch(MandateReturnReducerAction.resetGridRows());
        dispatch(MandateReturnReducerAction.updateSaveBtnDisable(false));
      }, 3000);
    } catch (error) {
      dispatch(MandateReturnReducerAction.updateSaveBtnDisable(false));
      setMessage("Mandate Return Save Failed.");
      setAlertType("error");
      openAlertHandler();
      console.log(error);
    }
  };

  const onChangeMandateNumber = async () => {
    // create on dynamic record.
    const newValue = formData.mandateNum;
    setMandateNumErrorMsg(
      newValue === null || newValue === undefined || newValue === ""
        ? "Please Enter Mandate Number"
        : ""
    );
    if (
      formData.mandateNum !== "" &&
      formData.mandateNum !== null &&
      formData.mandateNum !== undefined
    ) {
      setMandateNumErrorMsg("");
      try {
        const branchCodeValue = getSelectedBranchCode(
          filteredFormData.branchValue
        );
        const response = await axios.post("/mandate/getMandateVoucherNum", {
          mandateNum: formData.mandateNum,
          branch: filteredFormData.branchValue,
          branchCode: branchCodeValue,
          voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
            "MM/DD/YYYY"
          ),
        });
        let responseModelData = response.data;
        dispatch(
          MandateReturnReducerAction.updateVoucherNumArray(
            responseModelData.voucherNumList
          )
        );
        if (responseModelData.status) {
          // true means voucher nums loaded successfully.
          setMessage(responseModelData.message);
          setAlertType("success");
          openAlertHandler();
        } else {
          setMessage(responseModelData.message);
          setAlertType("error");
          openAlertHandler();
          setMandateNumErrorMsg(responseModelData.message);
          dispatch(
            MandateReturnReducerAction.updateMandateNumErrorHandler(true)
          );
          dispatch(MandateReturnReducerAction.resetValues(false));
          dispatch(MandateReturnReducerAction.updateMandateNumber(newValue));
        }
      } catch (error) {
        setMessage("Mandate Number Related Voucher Numbers Load Failed.");
        setAlertType("error");
        openAlertHandler();
        console.log(error);
      }
    } else {
      setMandateNumErrorMsg("Please Enter Mandate Number");
      dispatch(MandateReturnReducerAction.resetValues(true));
      dispatch(MandateReturnReducerAction.updateMandateNumErrorHandler(true));
    }
  };

  const onChangeVoucherNum = async (value) => {
    dispatch(MandateReturnReducerAction.updateVoucherNum(value));
    const currentMandateNum = formData.mandateNum;
    if (value && value !== "") {
      // validation mandate num whether added to return grid already.
      // check for duplicates.
      // get the latest records for save.
      const latestRecords = store.getState().mandateReturn.gridRows;
      const filteredRecords = latestRecords.filter(
        (row) => row.voucherNum === value
      );

      if (filteredRecords.length > 0) {
        setMandateNumErrorMsg("Mandate Number Already Entered for Return");
        dispatch(MandateReturnReducerAction.updateMandateNumErrorHandler(true));
        dispatch(MandateReturnReducerAction.resetValues(false));
        dispatch(
          MandateReturnReducerAction.updateMandateNumber(formData.mandateNum)
        );
        return;
      } else {
        // get the return reason value before reset.
        const returnReasonArrayValues = { ...formData }.returnReasonArray;
        const voucherNums = { ...formData }.voucherNumArray;
        const branchCodeValue = getSelectedBranchCode(
          filteredFormData.branchValue
        );
        const response = await axios.post("/mandate/getNachDataByMandateNum", {
          mandateNum: currentMandateNum,
          branch: filteredFormData.branchValue,
          branchCode: branchCodeValue,
          voucherNum: value,
          voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
            "MM/DD/YYYY"
          ),
        });
        if (response.data.status !== "PARTIAL_CONTENT") {
          let records = response.data.mandateReturn;
          dispatch(MandateReturnReducerAction.updateMandateNumRecords(records));
          const mandateAmt = Number(
            [...records]
              .map((row) => Number(row.mandateAmt))
              .reduce((a, b) => a + b)
          );
          const charges = Number(
            [...records]
              .map((row) => Number(row.charges))
              .reduce((a, b) => a + b)
          );
          const appNum = [...records]
            .map((row) => row.applicationNum + ", ")
            .reduce((a, b) => a + b);
          let record = { ...records[0] };
          record.addRecord = true;
          record.id = records[0]?.mandateNum;
          record.returnReasonArray = returnReasonArrayValues;
          record.voucherNumArray = voucherNums;
          record.applicationNum = appNum;
          record.mandateAmt = mandateAmt;
          record.charges = charges;
          // validate return reason.
          if (
            record.returnReason === null ||
            record.returnReason === undefined ||
            record.returnReason === ""
          ) {
            dispatch(
              MandateReturnReducerAction.updateReturnReasonTouchHandler(true)
            );
          }
          dispatch(MandateReturnReducerAction.updateValues(record));
          dispatch(
            MandateReturnReducerAction.updateMandateNumErrorHandler(false)
          );
          dispatch(
            MandateReturnReducerAction.updateVoucherNumTouchHandler(false)
          );
          setDlgBtnName("OK");
          setMessage("Mandate Data loaded Successfully.");
          setAlertType("success");
          openAlertHandler();
        }

        if (response.data.status === "PARTIAL_CONTENT") {
          setMessage(response.data.messsage);
          setAlertType("error");
          openAlertHandler();
          setMandateNumErrorMsg(response.data.messsage);
          dispatch(
            MandateReturnReducerAction.updateMandateNumErrorHandler(true)
          );
          dispatch(MandateReturnReducerAction.resetValues(false));
          dispatch(
            MandateReturnReducerAction.updateMandateNumber(currentMandateNum)
          );
        }
      }
    } else {
      // on voucher num remove.
      dispatch(MandateReturnReducerAction.updateVoucherNumTouchHandler(true));
      dispatch(MandateReturnReducerAction.resetValues(false));
      dispatch(
        MandateReturnReducerAction.updateMandateNumber(currentMandateNum)
      );
    }
  };

  return (
    <React.Fragment>
      <AccordianContainer
        id="accord"
        title="Mandate Return Information"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ float: "right" }}>
          <Tooltip title="Ctrl+A" placement="top">
            <Button
              size="small"
              sx={{ marginBottom: "2px" }}
              variant="contained"
              disabled={open}
              onClick={() => {
                setOpen(true);
                setDlgInputMode(true);
              }}
              ref={addRowRef}
            >
              {/* <Add fontSize="small" /> */}
              Add
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+S" placement="top">
            <Button
              sx={{
                marginLeft: "1rem",
              }}
              variant="contained"
              disabled={
                saveBtnDisable ||
                (deviceMode === "MOBILE"
                  ? rows.length === 0
                  : datarows.length === 0)
              }
              onClick={() => {
                dispatch(MandateReturnReducerAction.updateSaveBtnDisable(true));
                setTimeout(() => {
                  openAlertDialog();
                }, 1000);
              }}
              ref={saveRef}
            >
              SAVE
            </Button>
          </Tooltip>
        </Box>
        {useMediaQuery("(min-width:1200px)") && (
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            disabled={
              deviceMode === "MOBILE"
                ? rows.length === 0
                : datarows.length === 0
            }
            rows={datarows}
            // gridHeight={
            //   datarows.length < 5 && datarows.length !== 0
            //     ? datarows.length * 40 + 130
            //     : 330
            // }
            gridHeight={330}
            columns={gridColumns}
            rowHeight={40}
            pageSize={10}
            pageSizeOptions={[10]}
            pageValue={gridPaginationData.lastActivePage}
            gridLazyLoad={onGridPageChange}
            onSortModelChange={() => {}}
            rowDoubleClickHandler={rowDoubleClickHandler}
          />
        )}
        {useMediaQuery("(max-width:1200px)") && (
          <React.Fragment>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{ height: "60px", bgcolor: "white" }}
            >
              {totalRowsCount > 10 && (
                <Typography
                  sx={{
                    mr: 2,
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Page Max Records : " + rowsPerPage}
                </Typography>
              )}
              <Typography
                padding="1px"
                sx={{ color: "#004A92", fontWeight: 700 }}
              >
                {"Total Records : " + totalRowsCount}
              </Typography>
              <Pagination
                count={totalPageCount}
                color="primary"
                onChange={handlePageChange}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Grid>
            <Grid container>
              <Box
                sx={{
                  height: accordianOpen
                    ? window.innerHeight - 540
                    : window.innerHeight - 250,
                  overflow: "auto",
                  flex: "1 auto",
                }}
              >
                {rows.map((row, index) => (
                  <React.Fragment>
                    <Grid container direction="column" sx={{ flex: "1 auto" }}>
                      <Card>
                        <CardHeader
                          subheader={"Mandate Number : " + row.mandateNum}
                          subheaderTypographyProps={{
                            color: "#004A92",
                            fontWeight: "700",
                          }}
                          action={
                            <React.Fragment>
                              {!row.addRecord ? (
                                <IconButton size="small">
                                  <Edit
                                    fontSize="small"
                                    sx={{ color: "#004A92", fontWeight: 700 }}
                                    onClick={() => onRowEditClick(row)}
                                  />
                                </IconButton>
                              ) : (
                                <LoadActionBtn
                                  record={row}
                                  onMoreActionsClick={(value, record) =>
                                    onMoreActionBtnClick(value, record)
                                  }
                                />
                              )}
                            </React.Fragment>
                          }
                          sx={{
                            textAlign: "left",
                            padding: "16px 16px 0px 16px !important",
                          }}
                        />
                        <CardContent sx={{}}>
                          <Grid
                            container
                            item
                            direction="column"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            sx={{}}
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Mandate Date"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.mandateDate}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Application Number"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.applicationNum}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Mandate Amount"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${
                                  row.mandateAmt === "0"
                                    ? 0
                                    : parseInt(row.mandateAmt).toLocaleString(
                                        "en-IN"
                                      )
                                }`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Return Reason"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.returnReason}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Charges"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${
                                  row.charges === "0"
                                    ? 0
                                    : parseInt(row.charges).toLocaleString(
                                        "en-IN"
                                      )
                                }`}
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Divider />
                  </React.Fragment>
                ))}
                {rows.length === 0 && (
                  <NoDataFound
                    message={"No Mandate Return Data Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )}
              </Box>
            </Grid>
          </React.Fragment>
        )}
      </AccordianContainer>
      <Dialog
        open={open}
        fullScreen
        // onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <h4>{"Mandate Return Information"}</h4>
        </DialogTitle>
        <DialogContent>
          {
            <React.Fragment>
              <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
                <h4>{"Mandate Info"}</h4>
                <Grid container rowSpacing={0} columnSpacing={1}>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="text"
                      label="Mandate Number"
                      variant="standard"
                      required={dlgInputMode}
                      disabled={!dlgInputMode}
                      value={formData.mandateNum}
                      onBlur={(e) => {
                        onChangeMandateNumber();
                      }}
                      onChange={(event) => {
                        const newValue = event.target.value;
                        dispatch(
                          MandateReturnReducerAction.updateMandateNumber(
                            event.target.value ? event.target.value : ""
                          )
                        );

                        setMandateNumErrorMsg(
                          newValue === null ||
                            newValue === undefined ||
                            newValue === ""
                            ? "Please Enter Mandate Number"
                            : ""
                        );
                      }}
                    ></CustomTextField>
                    {mandateNumHasError && (
                      <p className="error">{mandateNumErrorMsg}</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomAutoComplete
                      label="Voucher Number"
                      variant="standard"
                      disabled={!dlgInputMode}
                      type="text"
                      required={true}
                      autoCompleteValues={formData.voucherNumArray}
                      value={formData.voucherNum}
                      onChange={(e, value) => {
                        onChangeVoucherNum(value);
                      }}
                      onBlur={() => {
                        dispatch(
                          MandateReturnReducerAction.updateVoucherNumTouchHandler(
                            true
                          )
                        );
                      }}
                    />
                    {voucherNumHasError && (
                      <p className="error">Please Select Voucher Number</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomDateField
                      type="Mandate Date"
                      label="Mandate Date"
                      variant="standard"
                      disabled={true}
                      value={formData.mandateDate}
                    ></CustomDateField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Application Number"
                      label="Application Number"
                      variant="standard"
                      disabled={true}
                      value={formData.applicationNum}
                    ></CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Mandate Amount"
                      label="Mandate Amount"
                      variant="standard"
                      disabled={true}
                      value={
                        formData.mandateAmt === "0"
                          ? 0
                          : parseInt(formData.mandateAmt).toLocaleString(
                              "en-IN"
                            )
                      }
                      onChange={(event, value) => {
                        dispatch(
                          MandateReturnReducerAction.updateMandateAmt(
                            event.target.value
                              ? event.target.value.replaceAll(",", "")
                              : 0
                          )
                        );
                      }}
                    ></CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomDropDown
                      type="Return Reason"
                      label="Return Reason"
                      variant="standard"
                      value={formData.returnReason}
                      disabled={false}
                      dropDownValue={formData.returnReasonArray}
                      onBlur={() => {
                        dispatch(
                          MandateReturnReducerAction.updateReturnReasonTouchHandler(
                            true
                          )
                        );
                      }}
                      onChange={(e) => {
                        dispatch(
                          MandateReturnReducerAction.updateReturnReason(
                            e.target.value
                          )
                        );
                      }}
                    />
                    {returnReasonHasError && (
                      <p className="error">Please Select Return Reason</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Charges"
                      label="Charges"
                      variant="standard"
                      disabled={true}
                      value={
                        formData.charges === "0"
                          ? 0
                          : parseInt(formData.charges).toLocaleString("en-IN")
                      }
                      onChange={(event, value) => {
                        dispatch(
                          MandateReturnReducerAction.updateCharges(
                            event.target.value
                              ? event.target.value.replaceAll(",", "")
                              : 0
                          )
                        );
                      }}
                    ></CustomTextField>
                    {chargesHasError && (
                      <p className="error">Please Enter Charges</p>
                    )}
                  </Grid>
                </Grid>
              </Paper>
              {dlgbtnName === "OK" && (
                <MandateReturnInfo dlgInputMode={dlgInputMode} />
              )}
            </React.Fragment>
          }
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={() => closeDialog()} ref={cancelRef}>
              CANCEL
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              disabled={
                formData.mandateNum === "" ||
                formData.mandateNum === undefined ||
                formData.mandateNum === null ||
                mandateNumHasError ||
                returnReasonHasError ||
                voucherNumHasError ||
                formData.returnReason === undefined ||
                formData.returnReason === "" ||
                formData.returnReason === null ||
                formData.voucherNum === undefined ||
                formData.voucherNum === "" ||
                formData.voucherNum === null
              }
              onClick={() =>
                dlgbtnName === "NEXT" ? setDlgBtnName("OK") : onDlgOkClick()
              }
              ref={okRef}
            >
              {dlgbtnName}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{dialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button ref={cancelDialogRef} onClick={handleDialogClose}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button ref={yesRef} onClick={onSaveButtonClickHandler}>
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default MandateReturnList;

const LoadActionBtn = (props) => {
  const [record, setRecord] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const req_mod_options = ["Edit", "Delete"];
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const modifyRef = useRef(null);
  const deleteRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "chequeReturnList",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();

    if (event.ctrlKey) {
      if (charCode === "m") {
        modifyRef.current.click();
      } else if (charCode === "b") {
        deleteRef.current.click();
      }
    }
  };

  useLayoutEffect(() => {
    setRecord(props.record);
  }, [props.record]);

  useEffect(() => {
    setRecord(props.record);
  }, [props.record]);

  const handleIconClick = (value, record) => {
    handleClose();
    props.onMoreActionsClick(value, record);
  };

  const ITEM_HEIGHT = 48;
  return (
    <React.Fragment>
      {record.addRecord && (
        <div>
          <Tooltip title="More Actions">
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleMenuClick}
            >
              <MoreVert sx={{ color: "#004A92", fontWeight: 700 }} />
            </IconButton>
          </Tooltip>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "100px",
              },
            }}
          >
            {req_mod_options.map((option, index) => (
              <MenuItem
                key={option}
                selected={option === "Pyxis"}
                onClick={() => handleIconClick(option, record)}
                ref={index === 0 ? modifyRef : deleteRef}
              >
                <IconButton size="small">
                  {(() => {
                    switch (index) {
                      case 0:
                        return (
                          <Tooltip title="Ctrl+M" placement="right">
                            <Edit
                              fontSize="small"
                              sx={{ color: "#004A92", fontWeight: 700 }}
                            />
                          </Tooltip>
                        );
                      case 1:
                        return (
                          <Tooltip title="Ctrl+B" placement="right">
                            <Delete
                              fontSize="small"
                              sx={{ color: "#004A92", fontWeight: 700 }}
                            />
                          </Tooltip>
                        );
                    }
                  })()}
                </IconButton>
                <Typography
                  color="#004A92"
                  variant="inherit"
                  component="div"
                  fontSize="14px"
                  fontWeight="inherit"
                >
                  {option}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </div>
      )}
    </React.Fragment>
  );
};
